import { createQueryKeys } from "@lukemorales/query-key-factory";
import axios from "axios";
import { CountriesApi } from "mws-ts-v2-sdk";

const getCountriesApi = () => {
  return new CountriesApi(
    undefined,
    useRuntimeConfig().public.financeServiceUrl,
    axios,
  );
};

export const countryQueryKeys = createQueryKeys("countries", {
  list: () => ({
    queryKey: ["all"],
    queryFn: async () => {
      const response = await getCountriesApi().v2CountriesGet();

      return response.data;
    },
  }),
});
